export default `<div class="styles__CategoryList">
  <div class="column featured">
    <div class="group featured">
      <span>
        <h2 class="title">Featured</h2>
      </span>
      <ul>
        <li><a href="/view/gear/" title="View All Gear"><div class="item"><div class="item-label">View All</div></div></a></li>
        <li><a href="/c/20070/gear?facets=new%3Afsm_newproduct%3Dnew&cm_sp=topnav_gear_featured_newarrivals" title="New Arrivals"><div class="item"><div class="item-label">New Arrivals</div></div></a></li>
        <li><a href="/content/clearance?MK=true&cm_sp=gear_featured_clearance&isclearcat=true" title="Clearance"><div class="item"><div class="item-label">Clearance</div></div></a></li>
      </ul>
    </div>
    <div class="group featured">
      <span>
        <h2 class="title">Activity</h2>
      </span>
      <ul>
        <li><a href="/view/shop-by-activity/hiking/backpacks/" title="Hiking Backpacks"><div class="item"><div class="item-label">Hiking Backpacks</div></div></a></li>

      </ul>
    </div>
  </div>
  <div class="column">
    <div class="group">
      <a href="/view/gear/" title="Gear">
        <h2 class="title">Gear</h2>
      </a>
      <ul>
        <li><a href="/view/gear/backpacks-and-packs/" title="Backpacks &amp; Packs"><div class="item"><div class="item-label">Backpacks</div></div></a></li>
        <li><a href="/view/gear/luggage/bags/type-duffel/" title="Duffel Bags"><div class="item"><div class="item-label">Duffels</div></div></a></li>
        <li><a href="/view/gear/flashlights-and-lanterns/" title="Flashlights &amp; Lanterns"><div class="item"><div class="item-label">Flashlights &amp; Lanterns</div></div></a></li>
        <li><a href="/view/gear/hydration/" title="Hydration"><div class="item"><div class="item-label">Hydration</div></div></a></li>
        <li><a href="/view/gear/luggage/" title="Luggage"><div class="item"><div class="item-label">Luggage</div></div></a></li>
        <li><a href="/view/gear/sleeping-bags/" title="Sleeping Bags"><div class="item"><div class="item-label">Sleeping Bags</div></div></a></li>
        <li><a href="/view/gear/sunglasses/" title="Sunglasses"><div class="item"><div class="item-label">Sunglasses</div></div></a></li>
        <li><a href="/view/gear/tents/" title="Tents"><div class="item"><div class="item-label">Tents</div></div></a></li>
        <li><a href="/view/gear/travel-accessories/" title="Travel Accessories"><div class="item"><div class="item-label">Travel Accessories</div></div></a></li>
        <li><a href="/view/gear/luggage/bags/type-tote/" title="Tote Bags"><div class="item"><div class="item-label">Tote Bags</div></div></a></li>
      </ul>
    </div>
  </div>
</div>`
